import Loading from '../../../Common/Loading';
import { usePeriodChartsDataContext } from './hooks/usePeriodChartsDataContext';
import { OcurrencesByDay } from './OcurrencesByDay';
import { OcurrencesByHour } from './OcurrencesByHour';
import { OcurrencesEvolution } from './OcurrencesEvolution';
import './styles/Charts.css';

export const Charts = () => {
    const { isLoading } = usePeriodChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <OcurrencesEvolution />
                <OcurrencesByDay />
            </div>
            <OcurrencesByHour />
        </>
    );
};
